import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../config/axios";
import { errorHandler, successHandler } from "../../../helpers/handlers";

const initialState = {
  config: null,
  pageLoading: false,
  actionLoading: false,
  entitlementResult: null,
  error: null,
};

const slice = createSlice({
  name: "aiConfig",
  initialState,
  reducers: {
    clearConfigError: (state) => {
      state.error = null;
    },
    clearEntitlementResult: (state) => {
      state.entitlementResult = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAiConfig.pending, (state) => {
        state.pageLoading = true;
        state.error = null;
      })
      .addCase(fetchAiConfig.fulfilled, (state, action) => {
        state.pageLoading = false;
        state.config = action.payload;
      })
      .addCase(fetchAiConfig.rejected, (state, action) => {
        state.pageLoading = false;
        state.error = action.payload;
      })

      .addCase(saveAiConfig.pending, (state) => {
        state.actionLoading = true;
        state.error = null;
      })
      .addCase(saveAiConfig.fulfilled, (state, action) => {
        state.actionLoading = false;
        state.config = action.payload;
      })
      .addCase(saveAiConfig.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      })

      .addCase(grantEntitlement.pending, (state) => {
        state.actionLoading = true;
        state.error = null;
        state.entitlementResult = null;
      })
      .addCase(grantEntitlement.fulfilled, (state, action) => {
        state.actionLoading = false;
        state.entitlementResult = action.payload;
      })
      .addCase(grantEntitlement.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearConfigError, clearEntitlementResult } = slice.actions;

export const fetchAiConfig = createAsyncThunk(
  "aiConfig/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/admin/ai/config");
      return response.data.payload;
    } catch (error) {
      errorHandler(error);
      return rejectWithValue(
        error.response?.data?.errors?.global || error.message
      );
    }
  }
);

export const saveAiConfig = createAsyncThunk(
  "aiConfig/save",
  async (patch, { rejectWithValue }) => {
    try {
      const response = await api.put("/admin/ai/config", patch);
      successHandler("AI config saved");
      return response.data.payload;
    } catch (error) {
      errorHandler(error);
      return rejectWithValue(
        error.response?.data?.errors?.global || error.message
      );
    }
  }
);

export const grantEntitlement = createAsyncThunk(
  "aiConfig/grantEntitlement",
  async ({ uid, tier, expiresAt, source = "comp" }, { rejectWithValue }) => {
    try {
      const body = { tier, source };
      if (expiresAt) body.expiresAt = expiresAt;
      const response = await api.put(
        `/admin/users/${encodeURIComponent(uid)}/entitlement`,
        body
      );
      successHandler("Entitlement updated");
      return response.data.payload;
    } catch (error) {
      errorHandler(error);
      return rejectWithValue(
        error.response?.data?.errors?.global || error.message
      );
    }
  }
);

export default slice.reducer;
